const DEFAULT_MAX_INPUT_LENGTH = 500;

const FIELD_LIMITS = {
  username: 120,
  password: 128,
  activation_code: 12,
  activation_token: 4096,
  otp: 12,
  udise_id: 20,
  captchaAnswer: 12,
  captchaId: 64,
  email: 160,
  emailOrMobile: 160,
  schEmail: 160,
  phone: 20,
  mobile: 20,
  token: 4096,
  authToken: 4096,
  accessToken: 4096,
  refresh_token: 4096,
};

const DANGEROUS_PATTERNS = [
  /<\s*script\b/gi,
  /\bjavascript\s*:/gi,
  /\bon\w+\s*=/gi,
  /(\$where|\$ne|\$gt|\$gte|\$lt|\$lte|\$regex|\$expr)\b/gi,
  /(\bunion\b\s+\bselect\b|;\s*drop\s+table|insert\s+into|delete\s+from)/gi,
];

const isControlChar = (character) => {
  const code = character.charCodeAt(0);
  return code <= 31 || code === 127;
};

const isPlainObject = (value) => value !== null && typeof value === "object" && !Array.isArray(value);

const isTextLikeField = (fieldType = "") => {
  const t = String(fieldType || "").toLowerCase();
  return ["", "text", "search", "email", "url", "tel", "textarea", "password"].includes(t);
};

const resolveMaxLength = (name, explicitMax) => {
  if (Number.isInteger(explicitMax) && explicitMax > 0) return explicitMax;
  const fromMap = FIELD_LIMITS[name];
  if (fromMap) return fromMap;
  return DEFAULT_MAX_INPUT_LENGTH;
};

export const sanitizeInputValue = (value, options = {}) => {
  if (typeof value !== "string") return value;
  const { type = "text", name = "", maxLength } = options;
  if (!isTextLikeField(type)) return value;

  let sanitized = Array.from(value)
    .filter((character) => !isControlChar(character))
    .join("");

  if (String(type).toLowerCase() !== "password") {
    sanitized = sanitized.replaceAll(/[<>`]/g, "");
    for (const pattern of DANGEROUS_PATTERNS) {
      sanitized = sanitized.replace(pattern, "");
    }
  }

  const finalLimit = resolveMaxLength(name, maxLength);
  if (sanitized.length > finalLimit) {
    sanitized = sanitized.slice(0, finalLimit);
  }

  return sanitized;
};

export const sanitizePayload = (payload, depth = 0) => {
  if (depth > 10) return payload;
  if (typeof payload === "string") {
    return sanitizeInputValue(payload, { type: "text" });
  }
  if (Array.isArray(payload)) {
    return payload.map((item) => sanitizePayload(item, depth + 1));
  }
  if (isPlainObject(payload)) {
    const out = {};
    for (const [key, value] of Object.entries(payload)) {
      out[key] = typeof value === "string"
        ? sanitizeInputValue(value, { name: key, type: "text" })
        : sanitizePayload(value, depth + 1);
    }
    return out;
  }
  return payload;
};

export const sanitizeQueryString = (url = "") => {
  try {
    const origin = typeof window !== "undefined" && window.location ? window.location.origin : "http://localhost";
    const parsed = new URL(url, origin);
    parsed.searchParams.forEach((value, key) => {
      parsed.searchParams.set(key, sanitizeInputValue(String(value), { name: key, type: "text" }));
    });
    return parsed.toString().replace(origin, "");
  } catch {
    return url;
  }
};
